import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { inViewport } from '../../shared/util';
import _ from 'underscore';
const tid = 'QHVNNVIT';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        props.requirePsychics();

        this.scrollListener = _.throttle(this.trackViewPromotion, 100);

        this.state = {
            view_promotion_sent: false,
            utm_term: props.utmterm || 'advisorlistLP',
        };
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.psychics != this.props.psychics) {
            return true;
        }

        return false;
    }

    componentDidUpdate(prevProps) {
        this.trackViewPromotion();
        if (prevProps.utmterm !== this.props.utmterm && this.props.utmterm) {
            this.setState({ utm_term: this.props.utmterm });
        }
    }

    render({ psychics }) {
        const utm_term = this.state.utm_term;
        const keen_url = new URL('https://bargestech.go2cloud.org/aff_c');
        keen_url.searchParams.set('offer_id', 209);
        keen_url.searchParams.set('aff_id', 1306);
        keen_url.searchParams.set('url_id', 41);
        keen_url.searchParams.set('aff_unique1', utm_term);

        if (psychics && Object.keys(psychics).length) {
            window.addEventListener('scroll', this.scrollListener);

            return (
                <keen-slider>
                    <row className='is-wrap is-aligned-center has-margin-20-bottom has-margin-10-left-mobile'>
                        <column className='is-8 is-12-mobile'>
                            <h2 className='has-margin-10-bottom has-weight-400'>Get Psychic Advice Now</h2>
                        </column>
                        <column className='is-12-mobile has-padding-35-right'>
                            <p>
                                <a
                                    href={keen_url}
                                    target='_blank'
                                    rel='sponsored noopener noreferrer'
                                >
                                    Powered by Keen
                                </a>
                            </p>
                        </column>
                    </row>
                    <row className='is-wrap is-justified-around'>
                        {Object.keys(psychics).map(key => this.renderPsychic(psychics[key], key, utm_term))}
                    </row>
                </keen-slider>
            );
        }

        return (<keen-slider />);
    }

    renderPsychic = (psychic, key, utm_term) => {
        let psychic_url = new URL('https://bargestech.go2cloud.org/aff_c');
        psychic_url.searchParams.set('offer_id', 209);
        psychic_url.searchParams.set('aff_id', 1306);
        psychic_url.searchParams.set('aff_unique1', utm_term);

        // Manually build the inner URL to avoid double encoding
        const base_url = `https://www.keen.com${psychic.detailsUrl}`;
        const separator = base_url.includes('?') ? '&' : '?';
        const psychic_details_url = `${base_url}${separator}tid=${tid}&partnereventid={transaction_id}&tune_offerid={offer_id}`; // eslint-disable-line max-len

        psychic_url = psychic_url.toString() + '&url=' + encodeURIComponent(psychic_details_url);

        return (
            <column className='is-6 is-12-mobile has-margin-10-top-mobile'>
                <a
                    className='keen-listing-container'
                    key={key}
                    href={psychic_url}
                    target='_blank'
                    rel='noopener sponsored noreferrer'
                    onClick={() => this.props.trackEvent([
                        'Click',
                        'Psychics_Slider:KeenAPI',
                    ])}
                >
                    <div className='keen-listing-price-container'>
                        <div className='offer-text'>
                        5 minutes for $1
                        </div>
                        <div className='listing-price'>
                            {psychic.serviceRate}/min
                        </div>
                    </div>
                    <row className='is-wrap is-aligned-center has-margin-10-bottom-mobile'>
                        <column className='is-6 is-flex is-justified-center'>
                            <div className='keen-image-container'>
                                <img
                                    src={psychic.picture.size500Version
                                        ? psychic.picture.size500Version.url
                                        : psychic.pictureURL}
                                    alt={psychic.speakerName}
                                    loading='lazy'
                                    className='keen-psychic'
                                    width='165'
                                    height='165'
                                />
                                <div className='dot' />
                            </div>
                        </column>
                        <column className='is-6 has-padding-5-left has-padding-20-left-mobile
                            has-padding-5-right has-padding-15-top'
                        >
                            <p className='psychic-name'>
                                <span>{psychic.speakerName}</span>
                            </p>
                            <p className='is-h5'>
                                <span>{psychic.averageRating}</span>
                                {[0, 1, 2, 3, 4].map(() => (
                                    <img
                                        src='https://gfx.tarot.com/images/daily-pages/daily-icons/keen-star.svg'
                                        width='auto'
                                        height='auto'
                                        loading='lazy'
                                        className='star'
                                        alt='Keen Psychic Rating Stars'
                                    />
                                ))}
                            </p>
                            <p className='is-h6 has-margin-15-left has-margin-10-bottom'>
                                {psychic.ratingCount.toLocaleString()} REVIEWS
                            </p>
                            <button className='is-pill'>CHAT NOW</button>
                        </column>
                    </row>
                </a>
            </column>
        );
    }

    trackViewPromotion = () => {
        if (
            !this.state.view_promotion_sent
            &&
            this.props.psychics
            &&
            inViewport('keen-slider', true)
        ) {
            window.removeEventListener('scroll', this.scrollListener);

            this.setState({
                view_promotion_sent: true,
            });

            this.props.trackViewPromotion({
                placement: 'keen-slider',
                id: 'Keen-API',
                name: 'Psychics_Slider:KeenAPI',
            });
        }
    }
}

const mapStateToProps = (state) => ({
    psychics: state.keen,
});

const mapDispatchToProps = (dispatch) => ({
    requirePsychics: () => dispatch({
        type: 'keen:init',
        payload: {
            tid: tid,
            size: 2,
        },
    }),
    trackEvent: (payload) => dispatch({
        type: 'ga:event',
        payload: payload,
    }),
    trackViewPromotion: (payload) => dispatch({
        type: 'ga:view_promotion',
        payload: payload,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
